import { LoadingIcon } from 'bc-front-sagacomponents';
import React, { useEffect, useState } from 'react';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { Route, RouteProps } from 'react-router';
import ForbiddenPage from '../../containers/ForbiddenPage';
import { setUnauthorizedApp } from '../../helpers/security';
import { RootState } from '../../redux/reducers';
import { getRoles, isAuthenticated, loginIfRequired } from '../../services/Authentification/authentification';
import { getProUrl } from '../../services/Config';
import { unregister } from '../../serviceWorkerRegistration';

export const useReduxSelector: TypedUseSelectorHook<RootState> = useSelector;

interface CustomProps {}

type Props = RouteProps & CustomProps;

/**
 * Composant définissant une route privée, c'est-à-dire nécessitant une authentification.
 */
function PrivateRoute(props: Props) {
  const [authenticated, setAuthenticated] = useState<boolean>(false);
  const [unauthorized, setUnauthorized] = useState<boolean>(false);

  const dispatch = useDispatch();
  const offline = useReduxSelector((state) => state.global.offline);
  const [error, setError] = useState(undefined);

  const { path, location } = props;
  const roles = getRoles();

  const tokenParsed = localStorage.getItem('token');

  const pathRetourRenouvellement = location?.pathname === '/contrats' && location.search === '?renouvellement';
  useEffect(() => {
    if (!isAuthenticated() && !offline) {
      if (pathRetourRenouvellement) {
        window.location.href = '/confirmation-renouvellement';
      }
      loginIfRequired()
        .then((isAuth) => {
          if (isAuth) {
            if (window.location.pathname === '/accueil') {
              dispatch({ type: 'RESET' }); //calls the root reducer with RESET as action!
            }
            setAuthenticated(true);
            // if (!infoUtilisateur) {
            //   history.push('/accueil');
            // }
          } else {
            setAuthenticated(isAuth);
            // if (!infoUtilisateur) {
            //   history.push('/accueil');
            // }
          }
        })
        .catch((error) => {
          setError(error);
        });
    } else if (offline && tokenParsed) {
      setAuthenticated(true);
    } else if (offline && !tokenParsed) {
      setAuthenticated(false);
    } else {
      setAuthenticated(true);
    }
  }, []);

  const urlSitePro = getProUrl();
  useEffect(() => {
    const isUnauthorized = setUnauthorizedApp(roles);
    setUnauthorized(isUnauthorized);
  }, [roles, path]);

  useEffect(() => {
    if (unauthorized && urlSitePro) {
      window.location.href = urlSitePro + '/accueil';
    }
  }, [unauthorized, urlSitePro]);
  useEffect(() => {
    if (!offline) {
      unregister();
    }
  }, []);
  if (error) {
    return <div>Impossible de se connecter !</div>;
  } else if (authenticated) {
    if (unauthorized && !urlSitePro) {
      return <ForbiddenPage />;
    } else {
      const { component, ...rest } = props;
      const Component: typeof React.Component = component as any;
      // tslint:disable-next-line: jsx-no-lambda
      return <Route {...rest} render={(props) => <Component {...props} />} />;
    }
  } else {
    return <LoadingIcon defaultColor />;
  }
}

export default PrivateRoute;
